import backpack from '~/assets/icons/backpack_2.svg';
import barmor from '~/assets/icons/barmor.svg';
import bracelet from '~/assets/icons/bracelet.svg';
import earrings from '~/assets/icons/earrings.svg';
import glasses from '~/assets/icons/glasses.svg';
import hat from '~/assets/icons/hat.svg';
import jacket from '~/assets/icons/jacket.svg';
import mask from '~/assets/icons/mask.svg';
import necklace from '~/assets/icons/necklace.svg';
import pants from '~/assets/icons/pants.svg';
import sneakers from '~/assets/icons/sneakers.svg';
import suit from '~/assets/icons/suit.svg';
import watch from '~/assets/icons/watch.svg';
import { ClothesShopCategoryIndex } from '~/rage';

export const CategoryNames = {
	[ClothesShopCategoryIndex.HAT]: 'Головные уборы',
	[ClothesShopCategoryIndex.TOP]: 'Верх',
	[ClothesShopCategoryIndex.PANTS]: 'Штаны',
	[ClothesShopCategoryIndex.SHOES]: 'Обувь',
	[ClothesShopCategoryIndex.ACCESSORIES]: 'Акссесуары',
	[ClothesShopCategoryIndex.GLASSES]: 'Очки',
	[ClothesShopCategoryIndex.MASK]: 'Маски',
	[ClothesShopCategoryIndex.BACKPACK]: 'Рюкзаки',
	[ClothesShopCategoryIndex.OUTFIT]: 'Костюмы',
	[ClothesShopCategoryIndex.EARS]: 'Серьги',
	[ClothesShopCategoryIndex.WATCHES]: 'Часы',
	[ClothesShopCategoryIndex.BRACELETS]: 'Браслеты',
	[ClothesShopCategoryIndex.ARMOR]: 'Бронежилеты',
};

export const CategoryImages = {
	[ClothesShopCategoryIndex.HAT]: hat,
	[ClothesShopCategoryIndex.TOP]: jacket,
	[ClothesShopCategoryIndex.PANTS]: pants,
	[ClothesShopCategoryIndex.SHOES]: sneakers,
	[ClothesShopCategoryIndex.ACCESSORIES]: necklace,
	[ClothesShopCategoryIndex.GLASSES]: glasses,
	[ClothesShopCategoryIndex.MASK]: mask,
	[ClothesShopCategoryIndex.BACKPACK]: backpack,
	[ClothesShopCategoryIndex.OUTFIT]: suit,
	[ClothesShopCategoryIndex.EARS]: earrings,
	[ClothesShopCategoryIndex.WATCHES]: watch,
	[ClothesShopCategoryIndex.BRACELETS]: bracelet,
	[ClothesShopCategoryIndex.ARMOR]: barmor,
};

export const categories = [
	{
		id: 0,
		type: ClothesShopCategoryIndex.HAT,
		name: CategoryNames[ClothesShopCategoryIndex.HAT],
		image: CategoryImages[ClothesShopCategoryIndex.HAT],
	},
	{
		id: 1,
		type: ClothesShopCategoryIndex.TOP,
		name: CategoryNames[ClothesShopCategoryIndex.TOP],
		image: CategoryImages[ClothesShopCategoryIndex.TOP],
	},
	// {
	// 	id: 2,
	// 	type: ClothesShopCategoryIndex.SHIRT,
	// 	name: CategoryNames[ClothesShopCategoryIndex.SHIRT],
	// 	image: CategoryImages[ClothesShopCategoryIndex.SHIRT],
	// },
	{
		id: 2,
		type: ClothesShopCategoryIndex.PANTS,
		name: CategoryNames[ClothesShopCategoryIndex.PANTS],
		image: CategoryImages[ClothesShopCategoryIndex.PANTS],
	},
	{
		id: 3,
		type: ClothesShopCategoryIndex.SHOES,
		name: CategoryNames[ClothesShopCategoryIndex.SHOES],
		image: CategoryImages[ClothesShopCategoryIndex.SHOES],
	},
	{
		id: 4,
		type: ClothesShopCategoryIndex.ACCESSORIES,
		name: CategoryNames[ClothesShopCategoryIndex.ACCESSORIES],
		image: CategoryImages[ClothesShopCategoryIndex.ACCESSORIES],
	},
	{
		id: 5,
		type: ClothesShopCategoryIndex.GLASSES,
		name: CategoryNames[ClothesShopCategoryIndex.GLASSES],
		image: CategoryImages[ClothesShopCategoryIndex.GLASSES],
	},
	{
		id: 6,
		type: ClothesShopCategoryIndex.MASK,
		name: CategoryNames[ClothesShopCategoryIndex.MASK],
		image: CategoryImages[ClothesShopCategoryIndex.MASK],
	},
	{
		id: 7,
		type: ClothesShopCategoryIndex.BACKPACK,
		name: CategoryNames[ClothesShopCategoryIndex.BACKPACK],
		image: CategoryImages[ClothesShopCategoryIndex.BACKPACK],
	},
	{
		id: 8,
		type: ClothesShopCategoryIndex.OUTFIT,
		name: CategoryNames[ClothesShopCategoryIndex.OUTFIT],
		image: CategoryImages[ClothesShopCategoryIndex.OUTFIT],
	},
	{
		id: 9,
		type: ClothesShopCategoryIndex.EARS,
		name: CategoryNames[ClothesShopCategoryIndex.EARS],
		image: CategoryImages[ClothesShopCategoryIndex.EARS],
	},
	{
		id: 10,
		type: ClothesShopCategoryIndex.WATCHES,
		name: CategoryNames[ClothesShopCategoryIndex.WATCHES],
		image: CategoryImages[ClothesShopCategoryIndex.WATCHES],
	},
	{
		id: 11,
		type: ClothesShopCategoryIndex.BRACELETS,
		name: CategoryNames[ClothesShopCategoryIndex.BRACELETS],
		image: CategoryImages[ClothesShopCategoryIndex.BRACELETS],
	},
	{
		id: 12,
		type: ClothesShopCategoryIndex.ARMOR,
		name: CategoryNames[ClothesShopCategoryIndex.ARMOR],
		image: CategoryImages[ClothesShopCategoryIndex.ARMOR],
	},
];

export const getCategoryByType = (type: ClothesShopCategoryIndex | null) => {
	return categories.find((category) => category.type === type);
};
